import { Component, OnInit, TemplateRef } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { Chart_Interface, Empty_Chart_Interface } from 'src/app/Interface/Chart_Interface';

import { Empty_Persone_List_Interface, Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ChartService } from 'src/app/Service/Chart/Chart.service';
import { ChartPersonService } from 'src/app/Service/Chart/ChartPerson.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PersonService } from 'src/app/Service/Person/Person.service';

@Component({
  selector: 'app-Chart',
  templateUrl: './Chart.component.html',
  styleUrls: ['./Chart.component.scss']
})
export class ChartComponent implements OnInit {
  Procssing:boolean=false


  constructor(
    private Chart_Service:ChartService,
    private ChartPerson_Service:ChartPersonService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private Person_Service:PersonService,
    private modalService: BsModalService
  ) { }


  DataList_Chart:Array<Chart_Interface>=[]
  Selected_Chart:Chart_Interface=Empty_Chart_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(2190).subscribe(
      data=>{
        this.ReadData_Chart()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Chart(){
    this.Procssing=true
    this.Chart_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Chart=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }



  //#region Edit

  modalRef_Edit: any;
  title_edit:String=''
  haghOzviayt_edit:number=0
  positionGrid_edit:number=0
  code_edit:String=''

  OnGet_Edit_Action(template: TemplateRef<any>,item: Chart_Interface) {
    this.Selected_Chart = item
    this.title_edit=this.Selected_Chart.title
    this.haghOzviayt_edit=this.Selected_Chart.haghOzviayt
    this.positionGrid_edit=this.Selected_Chart.positionGrid
    this.Copy_Item_Protocol=Empty_Chart_Interface()
    this.modalRef_Edit = this.modalService.show(template);
  }

  Edit() {
    if (!this.Selected_Chart.title.trim()) {
      this.Alertify_Service.ErrorMessage("عنوان را وارد نمائید.")
    }
    else {
      var temp: Chart_Interface = Empty_Chart_Interface()
      temp.id = this.Selected_Chart.id
      temp.parent = this.Selected_Chart.parent
      temp.title = this.title_edit
      temp.haghOzviayt = Number(this.haghOzviayt_edit)
      temp.positionGrid = Number(this.positionGrid_edit)

      this.Chart_Service.AddEdit(temp).subscribe(
        data => {
          if (data['id'] == -2) {
            this.Alertify_Service.ErrorMessage("عنوان وارد شده در این سطح موجود است")
          }
          else if (data['id'] == -1) {
            this.Alertify_Service.ErrorMessage("کد وارد شده در چارت موجود است")
          }
          else {
            this.Selected_Chart.title=this.title_edit
            this.Selected_Chart.haghOzviayt=this.haghOzviayt_edit
            this.Selected_Chart.positionGrid=this.positionGrid_edit
            this.Alertify_Service.SuccessMessage("اطلاعات ویرایش شد")
            this.modalRef_Edit.hide()
          }
        },
        error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  //#endregion

  //#region Add

  modalRef_Add: any;
  Add_Step_Title: string = ''
  Add_Step_Code: string = ''

  On_Add_Root(template: TemplateRef<any>) {
    var temp: Chart_Interface = Empty_Chart_Interface()
    this.OnGet_Add_Action(template,temp)
  }

  OnGet_Add_Action(template: TemplateRef<any>,item: Chart_Interface) {
    this.Selected_Chart = item
    this.Copy_Item_Protocol=Empty_Chart_Interface()
    this.Add_Step_Title=""
    this.Add_Step_Code=""
    this.modalRef_Add = this.modalService.show(template);
  }

  Add(id: number) {

    if (!this.Add_Step_Title.trim()) {
      this.Alertify_Service.ErrorMessage("عنوان را وارد نمائید.")
    }
    else {
      var temp: Chart_Interface = Empty_Chart_Interface()
      temp.title = this.Add_Step_Title


      if (id == 0) {
        temp.parent = this.Selected_Chart.id
      }
      else {
        temp.parent = this.Selected_Chart.parent
      }


      this.Chart_Service.AddEdit(temp).subscribe(
        data => {
          if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("عنوان وارد شده در این سطح تکراری است.")
          }
          else if (data.id == -1) {
            this.Alertify_Service.ErrorMessage("کد وارد شده تکراری است.")
          }
          else {
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
            this.ReadData_Chart()
            this.modalRef_Add.hide()
          }
        },
        error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  //#endregion

  //#region Delete

  modalRef_Delete: any;

  OnGet_Remove_Action(template: TemplateRef<any>,item: Chart_Interface) {
    this.Selected_Chart = item
    this.Copy_Item_Protocol=Empty_Chart_Interface()
    this.modalRef_Delete = this.modalService.show(template);
  }

  Delete(id: number) {

    this.Chart_Service.Delete(this.Selected_Chart.id,id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("اطلاعات حذف شد")
        this.ReadData_Chart()
        this.modalRef_Delete.hide()
      },
      error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  //#endregion

  //#region Order

  Copy_Item_Protocol: Chart_Interface = Empty_Chart_Interface();
  Copy_Item_Protocol_Up:Number=-1

  OnGet_Up_Action(item: Chart_Interface) {
    this.Copy_Item_Protocol = item
    this.Copy_Item_Protocol_Up = 1
    this.Alertify_Service.SuccessMessage("مقصد برای انتقال را انتخاب کنید.")
    /*
    this.Chart_Service.UpOrder(item.id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        this.ReadData_Chart()
      }
    )
    */
  }

  OnGet_Down_Action(item: Chart_Interface) {
    this.Copy_Item_Protocol = item
    this.Copy_Item_Protocol_Up = 0
    this.Alertify_Service.SuccessMessage("مقصد برای انتقال را انتخاب کنید.")
    /*
    this.Chart_Service.DownOrder(item.id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        this.ReadData_Chart()
      }
    )
    */
  }

  OnGet_Child_Action(item: Chart_Interface) {
    this.Copy_Item_Protocol = item
    this.Copy_Item_Protocol_Up = 2
    this.Alertify_Service.SuccessMessage("مقصد برای انتقال را انتخاب کنید.")
    /*
    this.Chart_Service.DownOrder(item.id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        this.ReadData_Chart()
      }
    )
    */
  }

  OnGet_Cut_Action(item: Chart_Interface) {

    if (this.Copy_Item_Protocol.id == 0) {
      this.Alertify_Service.ErrorMessage("موردی برای انتقال انتخاب نشده است")
    }
    else if (this.Copy_Item_Protocol_Up == 2)
    {
      this.Chart_Service.ChildOrder(this.Copy_Item_Protocol.id,item.id).subscribe(
        data => {
          if (data['id'] == -1)
          {
            this.Alertify_Service.ErrorMessage("!امکان انتقال به دلیل عدم همسطحی ، نیست")
          }
          else {
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
            this.ReadData_Chart()
            this.Copy_Item_Protocol=Empty_Chart_Interface()
          }

        }
      )
    }
    else {
      this.Chart_Service.CutOrder(this.Copy_Item_Protocol.id,item.id,this.Copy_Item_Protocol_Up==1).subscribe(
        data => {
          if (data['id'] == -1)
          {
            this.Alertify_Service.ErrorMessage("!امکان انتقال به دلیل عدم همسطحی ، نیست")
          }
          else {
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
            this.ReadData_Chart()
            this.Copy_Item_Protocol=Empty_Chart_Interface()
          }

        }
      )
    }
  }

  //#endregion

  //#region Person

  Swicher_Person_Tree:Chart_Interface=Empty_Chart_Interface()
  OnGet_Person_Action(template: TemplateRef<any>,item: Chart_Interface) {
    this.Swicher_Person_Tree=item
    this.modalRef_Person = this.modalService.show(template);
  }


  OnBack_From_Person() {
    this.Swicher_Person_Tree=Empty_Chart_Interface()
  }


  //#endregion  

  
  //#region  Person
  modalRef_Person: any;
  modalRef_Person_Delete: any;
  Procssing_Person: boolean = false
  Selected_Chart_Person:Persone_List_Interface=Empty_Persone_List_Interface()

  Personpage: number = 0;
  Filter_Familly: string = ''
  Filter_Area: string = ''

  Change_Filter() {
    this.Personpage = 0
  }

  ReadData_Person() {
    this.Procssing_Person = true

    this.Person_Service.GetActive().subscribe(
      data => {
        this.DataList_Person = data
        this.Procssing_Person = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  DataList_Person: Array<Persone_List_Interface> = []

  Set_Selected_Person_Record(item: Persone_List_Interface) {

    var Chekcer: boolean = false
    
    for (let detail of this.Swicher_Person_Tree.person) {
      if (detail.id == item.id ) {
        Chekcer = true
        break
      }
    }

    if (Chekcer) {
      this.Alertify_Service.ErrorMessage("کارشناس مورد نظر در لیست ثبت شده است")
    }
    else {

      this.modalRef_Person.hide()
      this.ChartPerson_Service.Add(this.Swicher_Person_Tree.id,item.id).subscribe(
        data=>{
          if(data['id']==-1)
            this.Alertify_Service.ErrorMessage(item.fullname + " در سمت "+ this.Swicher_Person_Tree.title +" موجود است")
          else
          {
            this.Alertify_Service.SuccessMessage(item.fullname + " در سمت "+ this.Swicher_Person_Tree.title +" اضافه شد")
            this.ReadData_Chart()
          }
        }
      )
    }

  }

  OnGet_Remove_Person_Action(template: TemplateRef<any>,item: Persone_List_Interface) {
    this.Selected_Chart_Person = item
    this.modalRef_Person_Delete = this.modalService.show(template);
  }

  Delete_Person() {
    this.modalRef_Person_Delete.hide()
    this.ChartPerson_Service.Delete(this.Selected_Chart_Person.codemeli).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("اطلاعات حذف شد")
        this.ReadData_Chart()

      },
      error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  //#endregion


}
